/**
 * @author Brendan Magee
 * @desc Simple datepicker that allows users to set a "must run by" date for a story
 * @example <pitch-date-picker pitch="pitch">
 *          </pitch-date-picker>
 */

import template from './pitchDatePicker.html';

class PitchDatePickerController {
  toggleDropdown($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.isOpen = !this.isOpen;
  }

  clearDate($event) {
    this.pitch.canHoldUntil = null;
    this.toggleDropdown($event);
  }
}

const pitchDatePicker = {
  template,
  bindings: {
    pitch: '<'
  },
  controller: 'PitchDatePickerController'
};

export default function (ngModule) {
  ngModule.component('pitchDatePicker', pitchDatePicker);
  ngModule.controller('PitchDatePickerController', PitchDatePickerController);
}
